import { render } from "./editLayerProductionProcess.vue?vue&type=template&id=3f832b52&ts=true"
import script from "./editLayerProductionProcess.vue?vue&type=script&lang=ts"
export * from "./editLayerProductionProcess.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__